import {useRef, useEffect} from 'react';
import {useMotionValue} from 'motion/react';

/**
 * Custom hook to track scroll progress for an element
 * @returns Object containing containerRef and scrollProgress
 */
export const useScrollProgress = () => {
    const containerRef = useRef<HTMLElement>(null);
    const scrollProgress = useMotionValue(0);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const handleScroll = () => {
            const rect = container.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const elementTop = rect.top;
            const elementHeight = rect.height;

            const progress = Math.max(
                0,
                Math.min(1, (windowHeight - elementTop) / (windowHeight + elementHeight)),
            );

            scrollProgress.set(progress);
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, [scrollProgress]);

    return {containerRef, scrollProgress};
};
